import React from 'react';
import SelectEntityFactory from '../Common/SelectEntityFactory';
import CourseActions from '../../actions/CourseActionCreator';
import { SearchTypes } from '../../constants/CentricConstants';

export default SelectEntityFactory(CourseActions.search, {searchType: SearchTypes.COURSES});
